import { createFileRoute } from '@tanstack/react-router';
import { AboutBlockEditorPage } from '@pages/about';

/** Block-Editor für eine Über-uns-Kategorie (/about/$categoryId) */
export const Route = createFileRoute('/_authenticated/about/$categoryId')({
  component: function AboutBlockEditorRoute() {
    const { categoryId } = Route.useParams();
    return <AboutBlockEditorPage categoryId={categoryId} />;
  },
});
